// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iItYN","tabsBox":"styles_tabsBox__1mvSa","createButton":"styles_createButton__228I8"};